<template>
    <section class="mb-8">
        <div class="relative bg-gray-900">
            <div aria-hidden="true" class="absolute inset-0 overflow-hidden">
                <img src="/images/header.png" alt="" class="w-full h-full object-center object-cover"/>
            </div>
            <div aria-hidden="true" class="absolute inset-0 bg-gray-900 opacity-50"/>
            <div class="relative max-w-3xl mx-auto py-12 px-6 flex flex-col items-center text-center sm:py-24 lg:px-0">
                <h1 class="text-4xl font-extrabold tracking-tight text-white lg:text-6xl">RekeningOpvuller</h1>
                <p class="mt-4 text-xl text-white">
                    Vul je rekening!
                </p>
            </div>
        </div>
    </section>

    <section class="container">
        <div class="mb-2">
            <h2 class="text-2xl font-extrabold tracking-tight text-gray-900">Vul je rekening bij:</h2>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            <Link
                v-for="webshop in webshops"
                :key="webshop.id"
                :href="webshop.url"
                :title="`Goedkoopste producten bij ${ webshop.name }`"
                class="relative aspect-h-1 aspect-w-1 rounded-lg flex flex-col overflow-hidden hover:opacity-75"
            >
                <span aria-hidden="true" class="absolute inset-0 w-full h-full ">
                    <img :src="webshop.image" :alt="webshop.name" class="w-full h-full object-center object-cover"/>
                </span>

                <span
                    aria-hidden="true"
                    class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-gray-400 opacity-10"
                />
            </Link>
        </div>
    </section>
</template>

<script>

import {Link} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link,
    },

    props: {
        webshops: {
            type: Object,
            required: true
        },
    },
}
</script>
